<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Edit'}}{{(type)? ' ' + type: ''}}</strong>
        </div>
        <div class="col-md-1">
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
  <div class="card-body">
  <div class>
    <div class="mb5"></div>
    <!-- <vform :formData="editForm" :fields="fields" :submitCallback="showSmallModal"/> -->
    <form @onsubmit.prevent action>
      <div class="row mb5">
        <div class="col-md-4"></div>
        <div class="col-md-2 text-center">
          <label class="form-control-label text-bold" >Min</label>
        </div>
        <div class="col-md-2 text-center">
          <label class="form-control-label text-bold">Max</label>
        </div>
        <div class="col-md-2 text-center">
          <label class="form-control-label text-bold">Number</label>
        </div>
        <div class="col-md-2 text-center">
          <label class="form-control-label text-bold">Text</label>
        </div>
      </div>
      <div class="row" v-for="field in fields" v-bind:key="field.name">
        <div class="form-group col-md-4 col-sm-6 col-xs-6" ><h2>{{getLabel(field.name)}}</h2></div>
        <div class="col-md-8" v-if="typeof (rawData[field.name]) == 'object'">
          <div class="row" v-for="(subF, ind) in rawData[field.name]" v-bind:key="subF.name+'_'+ind">
            <div class="col-md-3 col-sm-6 col-xs-6" v-for="(rate, rateInd) in ratingFields" v-bind:key="ind+rateInd">
              <div class="form-group" v-if="rate == 'min' || rate == 'max'">
                <!-- <label :for="field.name" class="form-control-label">{{getLabel(field.label)}}</label> -->
                <input
                  :type="'text'"
                  v-model="formData[field.name+'_'+ind+'_'+rate]"
                  :id="field.name+'_'+ind+'_'+rate"
                  :placeholder="'Enter '+rate"
                  class="form-control"
                >
                <small v-if="errors[field.name+'_'+ind+'_'+rate]" class="form-text text-danger">{{errors[field.name+'_'+ind+'_'+rate]}}</small>
                <small v-else-if="field.help" class="form-text text-muted">This is a help text</small>
              </div>
              <div class="form-group" v-else>
                <label :for="field.name" class="form-control-label">{{formData[field.name+'_'+ind+'_'+rate]}}</label>
                <input
                  :type="'hidden'"
                  v-model="formData[field.name+'_'+ind+'_'+rate]"
                  :id="field.name+'_'+ind+'_'+rate"
                  :placeholder="'Enter '+rate"
                  class="form-control"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group pull-right">
            <button @click="saveMacroData" type="button" class="btn btn-primary">Save</button>
          </div>
        </div>
      </div>
    </form>
    <PinCheck
      :show.sync="show"
      ref="smallModal"
      v-bind:small="true"
      @submitForm="submitForm"
      :cancelClass="'btn btn-secondary'"
    ></PinCheck>
  </div>
  </div>
  </div>
</template>
<script>
// import vform from "@/components/vform";
import { commonMixins } from "../../assets/mixins/common.js";
import http from "@/lib/http";
import PinCheck from "@/components/PinCheck.vue";
export default {
  name: 'DebtRating',
  components: { PinCheck },
  mixins: [commonMixins],
  created() {
    if (this.$route.params.type) {
      this.type = this.$route.params.type
      this.getRawData();
    } else {
      this.$router.go(-1);
    }
  },
  data() {
    return {
      show: false,
      fields: [],
      formData: {},
      errors: [],
      rawData: [],
      ratingFields: [],
      type: 'qualitativeStatements'
    };
  },
  methods: {
    submitEditForm: function() {
      let myself = this;
      console.log("submit form", this.formData);
      var formData = this.getFormData();
      http.put(
        "mutual-funds/form?name="+myself.type,
        formData,
        (error, response) => {
          console.log(response);
          if(response.message == 'success') {
            this.$toastr.success("Updated Successfully!", "", {});
          } else {
            this.$toastr.error("Oops, Something went wrong!", "", {});
          }
        }
      );
    },
    setData() {
      var fields = Object.keys(this.rawData);
      fields.forEach((val, key) => {
        if(typeof this.rawData[val] == 'object') {
          var subFields = [];
          this.rawData[val].forEach((subF, subKey) => {
            var ratings = Object.keys(subF);
            this.ratingFields = ratings;
            ratings.forEach((rate, rateK) => {
              subFields.push(        
                {
                  label: val+'_'+subKey+'_'+rate,
                  name: val+'_'+subKey+'_'+rate,
                  type: (rate=='number' || rate=='text')? 'label': 'number',
                  value: subF[rate]
                }
              );
            });            
          })
          console.log(subFields);
          this.fields.push(        
            {
              label: val,
              name: val,
              type: "head",
              subFields: subFields
            }
          );
        } else {
          this.fields.push(        
          {
            label: val,
            name: val,
            type: "number",
            value: this.rawData[val]
          }
        );
        }
      });
      console.log(this.fields);
    },
    getFormData () {
      var formData = {};
      var fields = Object.keys(this.rawData);
      fields.forEach((val, key) => {
        formData[val] = [];
        if(typeof this.rawData[val] == 'object') {
          var subFields = [];
          this.rawData[val].forEach((subF, subKey) => {
            formData[val][subKey] = {min: '', max: '', number: '', text: ''};
            this.ratingFields.forEach((rate, rateK) => {
              // subFields = {[rate]: this.formData[val+'_'+subKey+'_'+rate] };
              // console.log(subFields);
              formData[val][subKey][rate] = this.formData[val+'_'+subKey+'_'+rate];
            });
            // formData[val][subKey] = subFields;
          });
        }
      });
      console.log('formData', formData);
      return formData;
    },
    setFormData() {
      for (var index in this.fields) {
        let field = this.fields[index];
        if (!field.placeholder) field.placeholder = "";
        if (!field.value) field.value = "";
        if (!field.help) field.help = "";        
        if (field.subFields && field.subFields.length > 0) {
            let relatedData = field.subFields;
            for (var ind in relatedData) {
                let field1 = relatedData[ind];
                if (!field1.placeholder) field1.placeholder = "";
                // if (!field1.value) field1.value = "";
                if (!field1.help) field1.help = "";
                if (!field1.type) field1.type = "";
                this.$set(this.formData, field1.name, field1.value, field1.type);
            }
        } else {
          this.$set(this.formData, field.name, field.value);
        }
      }
      console.log("this.formData", this.formData);
    },
    getFixed(num) {
      let n = parseFloat(num).toFixed(2);
      return n != "NaN" ? n : "-";
    },
    cancel(d) {
      console.log("Cancel =>", d);
    },
    submitForm() {
      console.log("submitpin entered");
      // this.validatePin(pin);
      this.submitEditForm();
    },
    showSmallModal() {
      this.$refs.smallModal.open();
    },
    saveMacroData() {
      // this.submitForm();
      // this.formData["update"] = 0;
      this.$refs.smallModal.open();
    },
    updateMacroData() {
      // this.formData["update"] = 1;
      // this.$refs.smallModal.open();
    },
    getRawData() {
      http.get(
        "mutual-funds/form?name="+this.type,
        {},
        (error, response) => {
          if (response.message === 'success') {
            this.rawData = response.data;
            this.setData();
            this.setFormData();
          }
        }
      );
    }
  },
  watch: {
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/ratings-form.vue